// T-053: runs in <head> before first paint. The server writes data-ds-theme = system | light | dark (the user's
// choice, or the cookie on anonymous pages); this resolves «system» against the OS setting and keeps following it.
// `var` and the old-browser checks are kept on purpose: this file runs before anything else, on any browser.
/* eslint-disable no-var, @typescript-eslint/no-unnecessary-condition */
(function () {
  var root = document.documentElement;
  var media: MediaQueryList | null = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  function apply(): void {
    var pref = root.getAttribute('data-ds-theme') || 'system';
    var dark = pref === 'dark' || (pref === 'system' && media && media.matches);
    root.setAttribute('data-bs-theme', dark ? 'dark' : 'light');
  }
  apply();
  if (media && media.addEventListener) media.addEventListener('change', apply);
  window.dsApplyTheme = apply;
})();
